import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useLocation } from 'react-router-dom'

import { LoginPanel } from '../../components/panels'
import { acPostReconnect, acVerifyAuthCookie } from '../../store/actions'
import { ROUTES } from '../../store/constants'

/**
 * @description Renders the LoginPanel component and handles the authentication logic.
 *
 * @author Maria Eduarda Franke
 * @returns {React.Component} The LoginPage component.
 */
const LoginPage = () => {

    const dispatch = useDispatch()
    const location = useLocation()

    const {
        isAuthenticated,
        hasLoggedOut,

        isLoadingVerifyAuthCookie,
        isLoadingReconnect
    } = useSelector(state => state.auth)

    useEffect(() => {
        document.title = 'Manager | LCD'
    }, [])

    useEffect(() => {
        dispatch(acVerifyAuthCookie())
            .then((data) => {
                if (data.hasAuthCookie && !hasLoggedOut) {
                    dispatch(acPostReconnect())
                        .catch(err => console.error(err))
                }
            })
            .catch(err => console.error(err))
    }, [])

    if (isLoadingVerifyAuthCookie || isLoadingReconnect) {
        return <></>
    }

    if (isAuthenticated) {
        return <Navigate to={location.state?.from?.pathname || ROUTES.DASHBOARD} replace />
    }

    return (
        <LoginPanel />
    )
}

export default LoginPage